import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { ShoppingBag, LogOut, LayoutDashboard } from 'lucide-react';

export default function Navbar() {
  const { user, logout } = useAuth();
  const { cartCount } = useCart();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav style={{
      background: 'var(--charcoal)',
      padding: '0 2rem',
      height: '70px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      boxShadow: 'var(--shadow-lg)'
    }}>
      {/* Logo */}
      <Link to="/" style={{
        fontFamily: 'var(--font-display)',
        fontSize: '1.6rem',
        color: 'var(--soft-gold)',
        letterSpacing: '0.5px'
      }}>
        kraft<span style={{ color: 'var(--white)' }}>ova</span>
      </Link>

      {/* Nav Links */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
        <Link to="/" style={{ color: 'var(--light-gray)', fontSize: '0.95rem', transition: 'var(--transition)' }}
          onMouseOver={e => e.target.style.color = 'var(--soft-gold)'}
          onMouseOut={e => e.target.style.color = 'var(--light-gray)'}>
          Shop
        </Link>

        {/* Cart */}
        {user && user.role === 'user' && (
          <Link to="/cart" style={{ position: 'relative', color: 'var(--light-gray)' }}>
            <ShoppingBag size={22} />
            {cartCount > 0 && (
              <span style={{
                position: 'absolute', top: '-8px', right: '-8px',
                background: 'var(--soft-gold)', color: 'var(--charcoal)',
                borderRadius: '50%', width: '18px', height: '18px',
                fontSize: '0.7rem', fontWeight: '700',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>{cartCount}</span>
            )}
          </Link>
        )}

        {/* Auth Buttons */}
        {!user ? (
          <>
            <Link to="/login" style={{
              color: 'var(--light-gray)', fontSize: '0.95rem'
            }}>Login</Link>
            <Link to="/register" style={{
              background: 'var(--soft-gold)', color: 'var(--charcoal)',
              padding: '0.4rem 1.1rem', borderRadius: '8px',
              fontSize: '0.9rem', fontWeight: '600'
            }}>Register</Link>
          </>
        ) : (
          <>
            <Link to={user.role === 'admin' ? '/admin' : '/dashboard'}
              style={{ color: 'var(--light-gray)', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <LayoutDashboard size={18} />
              <span style={{ fontSize: '0.9rem' }}>
                {user.role === 'admin' ? 'Admin' : 'Dashboard'}
              </span>
            </Link>
            <button onClick={handleLogout} style={{
              background: 'transparent', border: '1px solid var(--mid-gray)',
              color: 'var(--light-gray)', padding: '0.35rem 0.9rem',
              borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '5px',
              fontSize: '0.9rem', transition: 'var(--transition)'
            }}>
              <LogOut size={16} /> Logout
            </button>
          </>
        )}
      </div>
    </nav>
  );
}